import { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AdminLayout from "./AdminLayout";
import AdminLogin from "./auth/AdminLogin";
import AdminGuard, { AdminRoleGuard } from "./auth/AdminGuard";
import { AdminAuthProvider } from "./auth/useAdminAuth";

const Dashboard = lazy(() => import("./pages/Dashboard"));
const Users = lazy(() => import("./pages/Users"));
const AppListings = lazy(() => import("./pages/AppListings"));
const Reports = lazy(() => import("./pages/Reports"));
const Orders = lazy(() => import("./pages/Orders"));
const Staff = lazy(() => import("./pages/Staff"));
const CMSHero = lazy(() => import("./pages/cms/CMSHero"));
const CMSCats = lazy(() => import("./pages/cms/CMSCategories"));
const CMSFeatures = lazy(() => import("./pages/cms/CMSFeatures"));
const CMSHowItWk = lazy(() => import("./pages/cms/CMSHowItWorks"));
const CMSFAQ = lazy(() => import("./pages/cms/CMSFAQ"));
const CMSPricing = lazy(() => import("./pages/cms/CMSPricing"));
const CMSWebsiteListings = lazy(() => import("./pages/cms/CMSWebsiteListings"));
const CMSTerms = lazy(() => import("./pages/cms/CMSTerms"));
const CMSPrivacy = lazy(() => import("./pages/cms/CMSPrivacy"));
const CMSAbout = lazy(() => import("./pages/cms/CMSAbout"));

const Fallback = () => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
    }}
  >
    Loading…
  </div>
);

export default function AdminApp() {
  const managerOnly = (element) => (
    <AdminRoleGuard roles={["admin", "super_admin"]}>
      {element}
    </AdminRoleGuard>
  );

  return (
    <AdminAuthProvider>
      <Suspense fallback={<Fallback />}>
        <Routes>
        <Route path="login" element={<AdminLogin />} />
        <Route
          element={
            <AdminGuard>
              <AdminLayout />
            </AdminGuard>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="users" element={<Users />} />
          <Route path="listings" element={<AppListings />} />
          <Route path="reports" element={<Reports />} />
          <Route path="orders" element={<Orders />} />
          <Route
            path="staff"
            element={(
              <AdminRoleGuard roles={["super_admin"]}>
                <Staff />
              </AdminRoleGuard>
            )}
          />
          <Route path="cms/hero" element={managerOnly(<CMSHero />)} />
          <Route path="cms/categories" element={managerOnly(<CMSCats />)} />
          <Route path="cms/features" element={managerOnly(<CMSFeatures />)} />
          <Route path="cms/howitworks" element={managerOnly(<CMSHowItWk />)} />
          <Route path="cms/faq" element={managerOnly(<CMSFAQ />)} />
          <Route path="cms/pricing" element={managerOnly(<CMSPricing />)} />
          <Route path="cms/websitelistings" element={managerOnly(<CMSWebsiteListings />)} />
          <Route path="cms/terms" element={managerOnly(<CMSTerms />)} />
          <Route path="cms/privacy" element={managerOnly(<CMSPrivacy />)} />
          <Route path="cms/about" element={managerOnly(<CMSAbout />)} />
          <Route path="*" element={<Navigate to="/admin" replace />} />
        </Route>
        </Routes>
      </Suspense>
    </AdminAuthProvider>
  );
}
